export enum TermsMethods {
  GET_TERMS = 'get_terms' as any
}
